/** Where a trip is in time — the one rule behind the booking and order spines' "now", the
 *  user record's Trips groups and the bookings list's `phase` (backend: the bookings
 *  list's phase namespace, every bucket a `start_ts` range).
 *
 *  The start decides first:
 *  - no start (or an unreadable one) → `undated`;
 *  - the start after now → `future`;
 *  - started: a missing end counts as the start, so a zero-length trip goes straight to
 *    `past`; `active` while the end is after now, `past` once it is at or before now.
 *
 *  A cancelled trip keeps its time phase — the caller shows its state beside it. */

export type TripPhase = 'past' | 'active' | 'future' | 'undated';

/** An instant as the wire and the time helpers carry it (`formatZoned`'s input). */
export type TripInstant = Date | string | number | null | undefined;

function ms(value: TripInstant): number | null {
  if (value === null || value === undefined || value === '') return null;
  const t = (value instanceof Date ? value : new Date(value)).getTime();
  return Number.isNaN(t) ? null : t;
}

export function tripPhase(start: TripInstant, end: TripInstant, now: Date = new Date()): TripPhase {
  const s = ms(start);
  if (s === null) return 'undated';
  const t = now.getTime();
  if (s > t) return 'future';
  return (ms(end) ?? s) > t ? 'active' : 'past';
}
